import type { Conversation } from '@customTypes/chat';
import { Role } from '@customTypes/types';
import { Avatar, Box, Flex, Indicator, Text, Title } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';

import { resolveImagePath } from '@/shared/helper';
import { useProfileStore } from '@/shared/store/profileStore';

import style from './ConversationItem.module.css';

import logo from '@/../public/Chat logo.png';

export const Conversationitem = ({
  conversation
}: {
  conversation: Conversation;
}) => {
  const navigate = useNavigate();
  const { profile, currentSessionId } = useProfileStore();
  const participantReceiver =
    conversation.participants.length > 2
      ? conversation.participants.filter((participant) =>
          profile?.role === Role.artist
            ? participant.chatProfile.profileType === Role.club
            : participant.chatProfile.profileType === Role.artist
        )
      : conversation.participants.filter((participant) => {
          const isSameProfile =
            profile?.role === Role.artist
              ? participant.chatProfile.artistProfileId === currentSessionId
              : participant.chatProfile.clubProfileId === currentSessionId;

          return !isSameProfile || participant.chatProfile.adminUserId !== null;
        });

  return (
    <Indicator
      inline
      color={conversation.newMessageCount === 0 ? 'transparent' : ''}
      offset={20}
      position='middle-end'
      size={16}
      label={
        conversation.newMessageCount === 0 ? '' : conversation.newMessageCount
      }
    >
      <Box
        className={style.container}
        onClick={() => {
          navigate({
            to: '/conversation/$conversationId',
            params: {
              conversationId: conversation.conversationId.toString()
            }
          });
        }}
      >
        {participantReceiver[0] && (
          <Flex align='center' bd={1} gap={10} p={8}>
            <div>
              <Indicator
                offset={6}
                position='bottom-end'
                color={
                  participantReceiver[0].chatProfile.profileType === Role.admin
                    ? 'green'
                    : participantReceiver[0].chatProfile.isOnline
                      ? 'green'
                      : 'gray'
                }
              >
                <Avatar
                  size='md'
                  src={
                    participantReceiver[0].chatProfile.profileType ===
                    Role.admin
                      ? logo
                      : resolveImagePath(
                          participantReceiver[0].chatProfile.avatarUrl
                        )
                  }
                />
              </Indicator>
            </div>
            <Flex direction='column'>
              <Title order={4}>
                {participantReceiver[0].chatProfile.profileType === Role.admin
                  ? 'Support'
                  : participantReceiver[0].chatProfile.displayName}
              </Title>
              {conversation.lastMessage && (
                <Text c='gray' fz={12}>
                  {conversation.lastMessage.content.length > 10
                    ? `${conversation.lastMessage.content.slice(0, 10)}...`
                    : conversation.lastMessage.content}
                </Text>
              )}
            </Flex>
          </Flex>
        )}
      </Box>
    </Indicator>
  );
};
